var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarAdd = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 4,
  fill: "#6B5CE8"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 10C16 10.1326 15.9473 10.2598 15.8536 10.3536C15.7598 10.4473 15.6326 10.5 15.5 10.5H10.5V15.5C10.5 15.6326 10.4473 15.7598 10.3536 15.8536C10.2598 15.9473 10.1326 16 10 16C9.86739 16 9.74021 15.9473 9.64645 15.8536C9.55268 15.7598 9.5 15.6326 9.5 15.5V10.5H4.5C4.36739 10.5 4.24021 10.4473 4.14645 10.3536C4.05268 10.2598 4 10.1326 4 10C4 9.86739 4.05268 9.74021 4.14645 9.64645C4.24021 9.55268 4.36739 9.5 4.5 9.5H9.5V4.5C9.5 4.36739 9.55268 4.24021 9.64645 4.14645C9.74021 4.05268 9.86739 4 10 4C10.1326 4 10.2598 4.05268 10.3536 4.14645C10.4473 4.24021 10.5 4.36739 10.5 4.5V9.5H15.5C15.6326 9.5 15.7598 9.55268 15.8536 9.64645C15.9473 9.74021 16 9.86739 16 10Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_add.ed4c05a013d8767f1a31142e3ec833bc.svg";